import React, { Component, Fragment } from "react";
import { BaseCellProps } from "../../VehicleFeatures";

interface WithOpenProps extends BaseCellProps {
    options: any[];
    render: (
        state: CellDropdownRenderProps,
        close: () => void,
        toggleOpen: () => void,
        makeSelection: (e: any) => void
    ) => any;
}

interface WithOpenState {
    isOpen: boolean;
}

export interface CellDropdownRenderProps extends WithOpenState {
    options: any[];
    title?: string;
    value: string;
}

class WithOpen extends Component<WithOpenProps, WithOpenState> {
    constructor(props: WithOpenProps) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    public render() {
        return (
            <Fragment>
                {this.props.render(
                    {
                        ...this.state,
                        options: this.props.options,
                        title: this.props.title,
                        value: this.props.value,
                    },
                    this.close,
                    this.toggleOpen,
                    this.makeSelection
                )}
            </Fragment>
        );
    }

    private close = () => {
        this.setState(() => {
            return {
                isOpen: false,
            };
        });
    };

    private toggleOpen = () => {
        this.setState(({ isOpen }) => {
            return {
                isOpen: !isOpen,
            };
        });
    };

    private makeSelection = (e: any) => {
        this.props.onUpdate(this.props.vin, this.props.dataKey, e.target.getAttribute("data-value"));
        this.setState({
            isOpen: false,
        });
    };
}

export default WithOpen;
